import { formatCount } from "../stages";
import type { MasterListStageData } from "../types";

/** The papers that the dataset must cover. */
export const MasterListStage = ({ data }: { data: MasterListStageData }) => (
  <div className="space-y-2">
    {data.papers != null ? (
      <p className="text-sm text-zinc-700">
        <span className="font-display text-3xl leading-none text-zinc-900">
          {formatCount(data.papers)}
        </span>{" "}
        papers
      </p>
    ) : (
      <p className="text-sm text-zinc-600">The agent is running the searches of the master list.</p>
    )}
    {data.result_id && <p className="font-mono text-2xs text-zinc-500">{data.result_id}</p>}
    {data.merged && (
      <p className="text-xs text-zinc-600">The list combines the results of several searches.</p>
    )}
    {data.limit_reached && (
      <p
        role="alert"
        className="rounded-[3px] border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
      >
        A search reached its document limit, so the list can be incomplete.
      </p>
    )}
  </div>
);
